import React, { createContext, useContext, useState, useEffect } from "react";
import EnquiryModal from "../components/EnquiryModal";
import products from "../data/products";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [wishlistSidebarOpen, setWishlistSidebarOpen] = useState(false);
  const [quickViewProduct, setQuickViewProduct] = useState(null);
  const [enquiryModalOpen, setEnquiryModalOpen] = useState(false);
  const [currentEnquiryProduct, setCurrentEnquiryProduct] = useState(null);
  const [enquiryProducts, setEnquiryProducts] = useState([]);
  const [tempEnquiryData, setTempEnquiryData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [enquiryItems, setEnquiryItems] = useState(() => {
    return JSON.parse(localStorage.getItem("enquiryItems") || "[]");
  });

  useEffect(() => {
    localStorage.setItem("enquiryItems", JSON.stringify(enquiryItems));
  }, [enquiryItems]);

  // Get best sellers from the imported products
  const bestSellers = products
    .filter((product) => product.rating >= 4.7)
    .slice(0, 3);

  const openQuickView = (productId) => {
    const product = products.find((p) => p.id === productId);
    setQuickViewProduct(product || null);
  };

  const closeQuickView = () => {
    setQuickViewProduct(null);
  };

  const toggleWishlist = (productId) => {
    setWishlist((prev) => {
      if (prev.includes(productId)) {
        return prev.filter((id) => id !== productId);
      }
      return [...prev, productId];
    });
  };

  const toggleWishlistSidebar = () => {
    setWishlistSidebarOpen(!wishlistSidebarOpen);
  };

  const addToCart = (productId, quantity = 1) => {
    const product = products.find((p) => p.id === productId);
    if (!product) return;

    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item.id === productId);
      if (existingItem) {
        return prevCart.map((item) =>
          item.id === productId
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }
      return [...prevCart, { ...product, quantity }];
    });
  };

  const addToEnquiry = (product) => {
    setEnquiryProducts((prev) => {
      if (!prev.some((p) => p.id === product.id)) {
        return [...prev, product];
      }
      return prev;
    });
    setEnquiryModalOpen(true);
  };

  return (
    <AppContext.Provider
      value={{
        cart,
        setCart,
        wishlist,
        setWishlist,
        wishlistSidebarOpen,
        setWishlistSidebarOpen,
        quickViewProduct,
        setQuickViewProduct,
        products,
        bestSellers,
        openQuickView,
        closeQuickView,
        toggleWishlist,
        toggleWishlistSidebar,
        addToCart,
        enquiryItems,
        setEnquiryItems,
        enquiryModalOpen,
        setEnquiryModalOpen,
        currentEnquiryProduct,
        setCurrentEnquiryProduct,
        enquiryProducts,
        setEnquiryProducts,
        addToEnquiry,
        tempEnquiryData,
        setTempEnquiryData,
      }}
    >
      {children}
      <EnquiryModal />
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
